import React from "react";
import Header from "../../components/landingPage/Header";
import Footer from "../../components/landingPage/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
// import { faSquareCheck, faCheck } from "@fortawesome/free-solid-svg-icons";

const TermsAndConditions = () => {
  return (
    <div className="bg-white">
      {/* header */}
      <Header className="static" />

      <div className="px-6 lg:px-32 xl:px-52 2xl:px-80 pt-32 lg:pt-48 pb-20 font-body">
        <h2 className="text-slate-900 text-2xl sm:text-3xl lg:text-4xl text-center pb-10 uppercase">
          Terms And Conditions
        </h2>
        <h2 className="font-body text-2xl font-normal text-justify text-slate-500 py-2">
          Terms and Conditions applicable to the use of the Drivado-Platform
          (including the drivado-App) and to the Services provided by
          Transportation Service Providers ("drivado T&C").
        </h2>
        <div className="my-5">
          <h2 className="font-body text-2xl font-semibold text-slate-900">
            I. General
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            1. Scope of Application.
          </h2>
          <h2 className="font-body py-1">
            These Terms and Conditions ("T&C") govern (i) the access and use of
            the website <Link
              to="https://www.drivado.com"
              className="font-body font-semibold hover:text-slate-600"
            >
              www.drivado.com
            </Link>, associated websites, the drivado-app and other
            content, websites, applications, products and services (in the
            following jointly referred to as "Platform") made available or
            supplied by Drivado Transfers Pvt. Ltd.("drivado"), and the (ii)
            arrangement of agreements on driver, mobility, and logistics
            services ("Services") through the Platform or by phone or email with
            service providers co-operating with Drivado ("Service Providers").
            Associated websites are websites other than the website <Link
              to="https://www.drivado.com"
              className="font-body font-semibold hover:text-slate-600"
            >
              www.drivado.com
            </Link> which
            Drivado uses to arrange agreements on Services and/or which third
            parties use to offer Services, or to arrange contracts on Services
            based on an agreement with drivado.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            2. About Drivado.
          </h2>
          <h2 className="font-body py-1">
            Drivado arranges agreements on Services ("Service Agreements") which
            are concluded between Users and Service Providers. "Users" in terms
            of these T&C are individuals and legal entities who use the
            Platform, with or without being registered with Drivado for the use
            of the Services or the Platform.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            3. Acceptance of T&C.
          </h2>
          <h2 className="font-body py-1">
            By accessing, registering for or using the Platform the User accepts
            the application of these T&C. Therefore, please read these T&Cs
            carefully before accessing or using the Platform.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            4. Modification of T&C.
          </h2>
          <h2 className="font-body py-1">
            Drivado reserves the right to make modifications of these T&C, which
            will be posted at this location. The modifications will only form
            part of the agreement, once the User has accepted these
            modifications. It is sufficient for this purpose, if Drivado informs
            the User of the new version of the T&C using the e-mail which has
            been provided by the User for notification purposes. In case the
            User does not object to the modifications of the T&C within four
            weeks, the acceptance shall be deemed as granted. As part of the
            e-mail, which is used to communicate the new version of the T&C,
            Drivado will inform the User about the possibility to object to the
            modification and regarding the meaning of the four-week-deadline.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            5. No application of T&C of user.
          </h2>
          <h2 className="font-body py-1">
            Terms and Conditions of the User are not applicable, even if Drivado
            does not explicitly object to their inclusion.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            6. Language of agreement.
          </h2>
          <h2 className="font-body py-1">
            The language of the agreement is English.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            7. Availability of these T&C.
          </h2>
          <h2 className="font-body py-1">
            The current version of the T&C shall always be displayed and Users
            are also authorized to print or save electronic copies.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            8. Data Privacy.
          </h2>
          <h2 className="font-body py-1">
            Drivado and Service Providers collect and store the personal data
            which is necessary to process the business transactions. They
            observe the legal requirements during the processing of the personal
            data. In addition, please refer to our privacy policy{" "}
            <Link to="/privacyPolicy" className="font-body">
              here
            </Link>
            .
          </h2>
        </div>

        <div className="my-5">
          <h2 className="font-body text-2xl font-semibold text-slate-900">
            II. Registration for the Platform and the Platform User Agreement
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            1. Registration process.
          </h2>
          <h2 className="font-body py-1">
            The registration of the User is not necessary to use the Platform.
            The registration is free of charge and requires that the User
            accepts these T&C. To complete the registration process, the User is
            required to provide certain details (e.g., first and last name,
            email). If the User requests registration online, the confirmation
            email is sent to User with all details. The User can always correct
            their details up before sending the request for registration. By
            completing the registration request process via web, app, phone or
            email the User submits a binding offer to conclude the agreement for
            the use of the Platform ("Platform User Agreement"). Drivado
            reserves the right to accept or reject the offer and there shall be
            no claims to the formation of a Platform User Agreement. If Drivado
            accepts the offer by the User to form a Platform User Agreement,
            Drivado will inform the User via e-mail to the e-mail address
            provided by the User and generate a user account for the User. The
            confirmation of the registration will be stored by Drivado, however,
            it will not be visible and accessible anymore to the User through
            the Platform.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            2. Entitlement to registration.
          </h2>
          <h2 className="font-body py-1">
            The registration is only possible for individuals who are not
            limited in their legal capacity, legal entities and partnerships.
            The registration of a legal entity or a partnership may only be
            carried out by an individual with power of attorney, who shall be
            identified by name.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            3. Accuracy of details.
          </h2>
          <h2 className="font-body py-1">
            The User is obliged to maintain accurate, up-to-date, and complete
            details in their account. Failure to keep accurate, up-to-date, and
            complete account details may result in the User's inability to
            access and use Services or Drivado's termination of this Agreement
            with the User.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            4. Communication via email.
          </h2>
          <h2 className="font-body py-1">
            Legally binding statements can be delivered to the User using the
            e-mail address stored in the account.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            5. Passwords.
          </h2>
          <h2 className="font-body py-1">
            The User is required to keep his password secret. S/He is not
            entitled to allow third parties to use his or her user account. As
            soon as the User is aware or has reason to believe that a third
            party is accessing his/her login details or otherwise gained or may
            gain access to his/her user account, s/he is obliged to notify
            Drivado about this fact immediately. Drivado is then entitled to
            block the User account until clarification of the issue.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            6. Liability for misuse of user account.
          </h2>
          <h2 className="font-body py-1">
            The User is liable to Drivado for all actions, which are carried out
            using User's account, unless the User is not responsible for such
            misuse.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            7. Termination.
          </h2>
          <h2 className="font-body py-1">
            The Platform User Agreement is entered into for an indefinite
            duration. The User can terminate this agreement at any time without
            prior notice by writing an email to{" "}
            <a
              href="mailto:support@drivado.com"
              alt=""
              className="font-body font-semibold hover:text-slate-600"
            >
              support@drivado.com
            </a>
            &nbsp;or declaring in written form by mail or hand delivery to:
            <br />
            <br />
            Drivado Transfers Pvt. Ltd.
            <br /> Merlin Infinite, <br />
                  Unit #506, DN-51, <br />
                  Street Number 11, DN Block, <br />
                  Sector V, Bidhannagar, Kolkata, <br />
                  West Bengal 700091, India.
            <br />
            <br />
            Drivado can also terminate this agreement with a User at any time
            without prior notice by communicating by email to the email address
            associated with the User account.
          </h2>
        </div>

        <div className="my-5">
          <h2 className="font-body text-2xl font-semibold text-slate-900">
            III. Service Agreements – Contractual Relationship & Conclusion
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            1. Contractual Relationship.
          </h2>
          <h2 className="font-body py-1">
            Drivado enables Users to arrange and schedule services with Service
            Providers (i.e. licensed chauffeur / limousine companies). Drivado
            arranges agreements on Services ("Service Agreement") which are
            concluded between the User and the Service Provider directly. Thus,
            Users are entitled to file claims against Service Providers
            directly. The User acknowledges that Drivado serves strictly as an
            intermediate or broker and not as a transportation service provider.
            The User shall have no claim to the formation or arrangement of
            Service Agreements.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            2. Conclusion of Service Agreements.
          </h2>
          <h2 className="font-body py-1">
            Service Agreements between the User and Service Providers are
            concluded through the Platform as follows: First the User indicates
            the desired service (e.g., one-way or hourly booking) and fills in
            the booking screen of the Platform. The fee for the Services will
            then be displayed for each booking class. The User then chooses a
            booking class and confirms his/her payment method, the associated
            billing details, and contact information supporting the provision of
            Services. The User can review and correct the details of his/her
            Service request ("Booking Request") before submitting the Booking
            Request by clicking the button "BOOK" (or a button with a similar
            indication). When a User submits a Booking Request whether via the
            Platform or by phone or by email to drivado, the User makes an offer
            for the conclusion of a Service Agreement with a Service Provider.
            Upon receiving a Booking Request, Drivado sends to the User an email
            to confirm the receipt of the Booking Request, including the details
            that were received. The Service Agreement between the User and the
            Service Provider only comes into effect upon Drivado's submission of
            a separate statement ("Ride Details") by email shortly before the
            ride, stating the name and contact details of the selected Service
            Provider. If Drivado cannot find a Service Provider to fulfil the
            Booking Request, Drivado will inform the User by email that the
            Booking Request cannot be fulfilled. In addition to these T&C, the
            Booking Conditions applicable at the time of booking shall apply.
            The Booking Conditions can be viewed at:{" "}
            <Link to="/bookingConditions" className="font-body font-semibold">
              Booking Conditions
            </Link>
            .
          </h2>
        </div>

        <div className="my-5">
          <h2 className="font-body text-2xl font-semibold text-slate-900">
            IV. The Cancellation of Service Agreements
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            1. Cancellation conditions.
          </h2>
          <h2 className="font-body py-1">
            The User may cancel Service Agreements free of charge or with costs
            according to the conditions which apply to the respective booking
            class agreed upon in the respective Service Agreement. The Booking
            Conditions are accessible at:{" "}
            <Link to="/bookingConditions" className="font-body font-semibold">
              Booking Conditions
            </Link>
            .
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            2. Cancellation only via Platform.
          </h2>
          <h2 className="font-body py-1">
            To warrant a smooth and save transaction, all cancellation requests
            must be made through the website{" "}
            <Link
              to="https://www.drivado.com"
              className="font-body font-semibold hover:text-slate-600"
            >
              www.drivado.com
            </Link>
            , the drivado app, by phone or by email. Drivado will confirm valid
            cancellations to the User by e-mail.
          </h2>
        </div>

        <div className="my-5">
          <h2 className="font-body text-2xl font-semibold text-slate-900">
            V. The payment of Fees due under the Service Agreements
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            1. Fees due.
          </h2>
          <h2 className="font-body py-1">
            All fees agreed upon in Service Agreements include possible charges
            and the statutory tax, if applicable. Unless agreed otherwise, the
            fee for bookings by route applies to the agreed journey without
            stopovers and without detours. In case of bookings by time or by
            route, the User must still pay the agreed amount of the fee if the
            passenger ends the journey early or shortens it.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            2. Invoices.
          </h2>
          <h2 className="font-body py-1">
            Drivado will send an invoice of the fees to the User (exclusively)
            by e-mail on behalf of the Service Provider.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            3. Payment method.
          </h2>
          <h2 className="font-body py-1">
            The fee shall be paid using the payment method chosen by the User
            during the booking process. For payments upon invoice the fee is
            payable within 10 days after notification of the invoice.
          </h2>
        </div>

        <div className="my-5">
          <h2 className="font-body text-2xl font-semibold text-slate-900">
            VI. Liability of drivado under the Platform User Agreement and of
            Service Providers under Service Agreements
          </h2>
          <h2 className="font-body py-1">
            1. Drivado shall only be liable towards the User, in particular in
            regards to its contractual obligations under the Platform User
            Agreement and any obligations in regards to the arrangement of
            Service Agreements, according to this Section VI. In no event shall
            Drivado be liable for any actions or omissions by Service Providers,
            in particular under any Service Agreement. Neither Service Providers
            nor drivers it employs or subcontracts are neither vicarious agents
            nor subcontractors of Drivado.
            <br />
            <br />
            2. The liability of drivado towards the User, in particular
            according to the Platform User Agreement, and the liability of
            Service Providers towards the User, in particular according to
            Service Agreements, are governed by the following rules:
            <br />
            <br />
            3. Drivado and the Service Provider respectively assume unlimited
            liability for damages caused wilfully or as a result of gross
            negligence by them, by their employees and by their vicarious
            agents, as well as in the event of fraudulent non-disclosure of
            defaults, explicit guarantees and damages arising from personal
            injuries (life, body and health).
            <br />
            <br />
            4. Drivado and the Service Provider respectively shall only be
            liable for other damages if they are in violation of an obligation,
            which must be observed to make the due performance of the agreement
            possible and on whose observation the other party to the agreement
            can usually rely. At the same time, the liability for damages is
            limited to those damages, which are deemed typical for this type of
            contract and foreseeable. Possible liabilities according to product
            liability law remain unaffected.
            <br />
            <br />
            5. Drivado does not warrant or assume liability for obligations
            according to arranged Service Agreements. In particular, Drivado is
            then not liable for the non-compliance with regulations under public
            law by Service Providers.
            <br />
            <br />
            6. Furthermore, Drivado shall not be liable for the accuracy,
            reliability, and completeness of the contents and programmes
            provided by Drivado on the Platform free of charge as well as
            damages, which may arise from them.
          </h2>
        </div>

        <div className="my-5">
          <h2 className="font-body text-2xl font-semibold text-slate-900">
            VII. Final Provisions for both the Platform User Agreement and the
            Service Agreements
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            1. Assignment.
          </h2>
          <h2 className="font-body py-1">
            Drivado is entitled to completely or partially assign all rights and
            obligations derived from the Platform User Agreement to a third
            party giving 4 weeks prior notice; in this case the User may
            terminate the User Agreement for good cause.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            2. Force majeure.
          </h2>
          <h2 className="font-body py-1">
            If events or circumstances outside Drivado's or a Service Provider's
            sphere of influence (force majeure) make the performance of their
            respective contractual obligations impossible, drivado or the
            Service Provider, whoever is affected, shall be relieved from their
            obligation to perform. In particular, the disruption or outage of
            the internet or other networks, telecommunications connections,
            power supply or other infrastructures as well as disruptions or
            defaults produced by providers or suppliers as well as severe
            weather are considered force majeure.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            3. Governing law.
          </h2>
          <h2 className="font-body py-1">
            The Platform User Agreement and Service Agreements shall each be
            governed exclusively by the law of the Local Courts of Kolkata,
            India.
          </h2>
          <h2 className="font-body text-2xl font-semibold text-slate-500 py-2">
            4. Venue.
          </h2>
          <h2 className="font-body py-1">
            For those Users, who are registered business people, the agreed
            venue for all legal disputes which may arise in relation with this
            agreement and the individual agreements shall be Kolkata.
          </h2>
        </div>

        <div className="my-5">
          <h2 className="font-body text-2xl font-semibold text-slate-900">
            VIII. Company Identification
          </h2>
          <h2 className="font-body py-1">
            <br />
            The contact details of drivado are as follows:
            <br />
            <br />
            Drivado Transfers Pvt. Ltd.
            <br />Merlin Infinite, <br />
                  Unit #506, DN-51, <br />
                  Street Number 11, DN Block, <br />
                  Sector V, Bidhannagar, Kolkata, <br />
                  West Bengal 700091, India.
          </h2>
        </div>
      </div>

      {/* footer */}
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
